import React from 'react';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { FooterStyles, RectangleShapeStyles } from './Footer.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Footer(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size, loading } = props;

	return (
		<SkeletonContainer
			className={FooterStyles({ size })}
			shapeColorClassName="bg-icon-weak"
			shapeSize={size}
			loading={loading}
		>
			<Rectangle className={RectangleShapeStyles({ size })} rounded />
			<Circle />
			<Circle />
		</SkeletonContainer>
	);
}
